/**
 * Returns the specified number of minutes as milliseconds.
 *
 * @param minutes The number of minutes to convert.
 * @return The number of milliseconds.
 */
export function minutes(minutes: number): number {
  return 1000 * 60 * minutes;
}
